import React from 'react';
import { FadeIn } from './FadeIn';
import { Button } from './Button';
export function Offer() {
  return <section id="offer" className="py-24 px-6 bg-brown-900 text-cream-50 text-center relative overflow-hidden scroll-mt-8" data-id="element-128">
      <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/stardust.png')] opacity-10 pointer-events-none" data-id="element-129"></div>

      <div className="max-w-3xl mx-auto relative z-10" data-id="element-130">
        <FadeIn data-id="element-131">
          <h2 className="text-3xl md:text-4xl font-bold mb-8 text-gold-400 leading-tight" data-id="element-132">
            Un hogar en paz es el tesoro más grande que le puedes heredar a tus
            hijos.
          </h2>

          <p className="text-xl md:text-2xl text-cream-100 mb-12" data-id="element-133">
            Por una ofrenda única de{' '}
            <span className="text-3xl font-bold text-gold-400 font-serif mx-1" data-id="element-134">
              $6.36
            </span>
            , obtén todas las herramientas para levantar el altar de Dios en tu
            casa hoy mismo.
          </p>

          <Button href="https://thealphamethods.com/cart/44267718836310:1" target="_blank" rel="noopener noreferrer" className="w-full md:w-auto text-lg md:text-xl py-5 px-10 shadow-gold-500/20 shadow-2xl" data-id="element-135">
            DESCARGAR MI GUÍA Y EMPEZAR LA UNCIÓN AHORA
          </Button>
        </FadeIn>
      </div>
    </section>;
}